import {ChartConfig} from '@models/machine/chart-config';
import {Machine} from '@models/machine/machine';
import {LocationDetails} from '@models/locationDetails/location-details';

// this class is used in the request send for adding a machine and contains just some of the machine properties, not all
export class MachineAddProperties {
  location: string = '';
  locationDetails: LocationDetails = new LocationDetails();
  name: string = '';
  parentId: number = -1;
  type: string = '';
  category: string = '';
  chartConfig: ChartConfig = new ChartConfig;
  dataSourcePartitioning: boolean = false;
  projectId: string = '';
  datasetLocation: string = '';
  tableauProjectId: string = '';
  signals: any;
  tableauViews: any;
  adminSharedPages: any;
  machineTag: string | undefined = '';
  externalId: string;
  parentExternalId: string;
  templateMachine: boolean;
  machineCategoryId: number | undefined;

  constructor(machine: Machine) {
    this.location = machine.location;
    this.locationDetails = machine.locationDetails;
    this.name = machine.name;
    this.parentId = machine.parentId;
    this.type = machine.type;
    this.category = machine.category;
    this.chartConfig = machine.chartConfig;
    this.dataSourcePartitioning = machine.dataSourcePartitioning;
    this.projectId = machine.projectId;
    this.datasetLocation = machine.datasetLocation;
    this.tableauProjectId = machine.tableauProjectId;
    this.signals = machine.signals;
    this.tableauViews = machine.tableauViews;
    this.adminSharedPages = machine.adminSharedPages;
    this.machineTag = machine.machineTag;
    this.externalId = machine.externalId;
    this.parentExternalId = machine.parentExternalId;
    this.templateMachine = machine.templateMachine;
    this.machineCategoryId = machine.machineCategoryId;
  }
}
